export const TRADING_STATUSES = ['Domestic', 'Foreign'];

/** Suggested trading status from a vessel's flag. Only a starting point — the
 * status describes the voyage, so whoever books can change it. */
export function tradingStatusForFlag(flag) {
  if (!flag) return '';
  return flag.trim().toLowerCase() === 'philippines' ? 'Domestic' : 'Foreign';
}
